import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import Toaster from "./components/reusable-toaster/Toaster";
import { Security } from "@okta/okta-react";
import { oktaAuth } from "./utils/oktaConfig";
import { toRelativeUrl } from "@okta/okta-auth-js";
// import ScrollToTop from "./components/ScrollToTop";

const App: React.FC = () => {
  const restoreOriginalUri = async (_oktaAuth: any, originalUri: string) => {
    const restoreUri = toRelativeUrl(
      originalUri || "/manage-inspector",
      window.location.origin,
    );

    window.location.replace(
      restoreUri === "/login" ? "/manage-inspector" : restoreUri,
    );
  };

  return (
    <div>
      <Toaster />
      <Router>
        {/* <ScrollToTop /> */}
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
          <AppRoutes />
        </Security>
      </Router>
    </div>
  );
};

export default App;
